import { render, staticRenderFns } from "./UpdatePermissionsToRole.vue?vue&type=template&id=749904a6&"
import script from "./UpdatePermissionsToRole.vue?vue&type=script&lang=js&"
export * from "./UpdatePermissionsToRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports